import { singletonHook } from 'react-singleton-hook';
import useArtifactInfoService from '../artifactInfoService';
import type { ArtifactsInfoResponse } from '../types';
import useCreateArtifactsInfoReceiver, { filterValidArtifactIds } from './createArtifactsInfoReceiver';

type ProjectArtifactsInfoReceiver = {
  hookLoading: boolean;
  collectProjectArtifactsData: (initialAttachmentsIds: string[]) => Promise<ArtifactsInfoResponse['artifacts']>;
};

const initState: ProjectArtifactsInfoReceiver = {
  hookLoading: true,
  collectProjectArtifactsData: async () => ({}),
};

const useProjectArtifactsInfoReceiverImpl = () => {
  const { getProjectArtifactsInfo } = useArtifactInfoService();

  const collectProjectArtifactsData = useCreateArtifactsInfoReceiver({
    getArtifactsInfo: getProjectArtifactsInfo,
    getBatchIds: filterValidArtifactIds,
  });

  return {
    hookLoading: false,
    collectProjectArtifactsData,
  };
};

const useProjectArtifactsInfoReceiver = singletonHook(initState, useProjectArtifactsInfoReceiverImpl);

export default useProjectArtifactsInfoReceiver;
